module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-square-dotted-52bf58ed.svg";